// import {
//   BrandPayload,
//   BrandSubmitForm,
//   Brands,
//   UpdateBrandStatus,
// } from "models/brand";
// import { BrandLocationPayload, BrandLocations, BrandList } from "models/brandLocation";
import { StoreList, updateAdminUserForm } from "models/adminManage";
import axiosClient from "./axiosClient";
import { ApiResponse, ImageUrlData, RemovePayload } from "models";
// import { ApiResponse, RemovePayload } from "models";

const adminUserMgmtAdminApi = {
  getRoleList(): Promise<any> {
    const url = "/accessRoleModuleManage/getAllAccessRole";
    return axiosClient.get(url);
  },

  getAdminUsersList(data: any): Promise<any> {
    const url = `/adminUserManage/getallAdminUserData?limit=${
      data.limit || ""
    }&page=${data.page || ""}&selectCountry=${
      data.selectCountry || ""
    }&search=${data.search || ""}&sortField=${data.sortName || ""}&sortType=${
      data.sortType || ""
    }`;
    return axiosClient.get(url);
  },

  getAdminUsersById(id: any): Promise<any> {
    const url = `/adminUserManage/getAdminUserById?id=${id}`;
    return axiosClient.get(url);
  },

  addAdminUser(data: any): Promise<ApiResponse> {
    const url = `/adminUserManage/addAdminUserManage`;
    return axiosClient.post(url, data, {
      // headers: {
      //   "Content-Type": "multipart/form-data",
      // },
    });
  },

  updateAdminUser(data: updateAdminUserForm): Promise<ApiResponse> {
    const url = `/adminUserManage/updateAdminUser`;
    return axiosClient.put(url, data);
  },

  getImageUrl(data: ImageUrlData): Promise<ApiResponse> {
    const url = `/settings/uploadImage`;
    return axiosClient.post(url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  },

  storeListApi(data: StoreList): Promise<ApiResponse> {
    const url = `/store/getStoreByBrandId?brandId=${data.brandId}`;
    return axiosClient.get(url, {});
  },

  deleteAdminUser(data: RemovePayload): Promise<ApiResponse> {
    const url = `/adminUserManage/removeAdminUser?id=${data._id}`;
    return axiosClient.post(url);
  },

  //   brandListApi(data: BrandList): Promise<ApiResponse> {
  //     const url = `/brand/getBrandByCustomerId?customerID=${data.customerId}`;
  //     return axiosClient.get(url, {});
  //   },
};

export default adminUserMgmtAdminApi;
